// Flattened index of every topic across Maths, English and Science for
// the global topic search bar. Cheap to import because the underlying
// section files are already loaded by the hubs.

import { mathsSections } from './mathsContent';
import { englishSections } from './englishContent';
import { biologySections, chemistrySections, physicsSections } from './scienceContent';
import { geographySections } from './geographyContent';

const forSubject = (subject, sections, { urlBuilder }) => {
  const out = [];
  sections.forEach((section) => {
    (section.topics || []).forEach((t) => {
      // Skip scaffolded / coming-soon topics — they have no content to search.
      if (!t.learn && !t.practice) return;
      out.push({
        subject,
        subjectLabel: subject.charAt(0).toUpperCase() + subject.slice(1),
        sectionTitle: section.title,
        sectionSlug: section.slug,
        topicId: t.id,
        topicSlug: t.slug,
        title: t.title,
        summary: t.summary || t.description || '',
        href: urlBuilder(section, t),
      });
    });
  });
  return out;
};

const buildScienceIndex = (disc, sections) =>
  forSubject('science', sections, {
    urlBuilder: (section, t) => `/science/${disc}/${section.slug}/${t.slug}`,
  }).map((row) => ({
    ...row,
    subjectLabel: `Science — ${disc.charAt(0).toUpperCase() + disc.slice(1)}`,
    disciplineSlug: disc,
  }));

export const TOPIC_INDEX = [
  ...forSubject('maths', mathsSections, {
    urlBuilder: (section, t) => `/maths/${section.slug}/${t.slug}`,
  }),
  ...forSubject('english', englishSections, {
    urlBuilder: (section, t) => `/english/${section.slug}/${t.slug}`,
  }),
  ...buildScienceIndex('biology', biologySections),
  ...buildScienceIndex('chemistry', chemistrySections),
  ...buildScienceIndex('physics', physicsSections),
  ...forSubject('geography', geographySections, {
    urlBuilder: (section, t) => `/geography/${section.slug}/${t.slug}`,
  }),
];

export function searchTopics(rawQuery, limit = 20) {
  const q = (rawQuery || '').trim().toLowerCase();
  if (!q) return [];
  const terms = q.split(/\s+/).filter(Boolean);
  const scored = [];
  for (const row of TOPIC_INDEX) {
    const haystack = `${row.title} ${row.sectionTitle} ${row.summary} ${row.subjectLabel}`.toLowerCase();
    let score = 0;
    for (const term of terms) {
      if (!haystack.includes(term)) {
        score = -1;
        break;
      }
      // Prioritise matches in the title.
      if (row.title.toLowerCase().includes(term)) score += 3;
      if (row.sectionTitle.toLowerCase().includes(term)) score += 1;
      score += 1;
    }
    if (score > 0) scored.push({ ...row, score });
  }
  scored.sort((a, b) => b.score - a.score);
  return scored.slice(0, limit);
}
